export default "__VITE_ASSET__BrVg8hPp__"